import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext({ user: null, login: () => {}, register: () => {}, logout: () => {}, refresh: () => {} });

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem("empco_user") || "null"); }
    catch { return null; }
  });
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const tok = localStorage.getItem("empco_token");
    if (!tok) { setReady(true); return; }
    api.get("/auth/me")
      .then((r) => { setUser(r.data); localStorage.setItem("empco_user", JSON.stringify(r.data)); })
      .catch(() => { localStorage.removeItem("empco_token"); localStorage.removeItem("empco_user"); setUser(null); })
      .finally(() => setReady(true));
  }, []);

  const _persist = (data) => {
    localStorage.setItem("empco_token", data.token);
    localStorage.setItem("empco_user", JSON.stringify(data.user));
    setUser(data.user);
  };

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    _persist(data);
    return data.user;
  };
  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    _persist(data);
    return data.user;
  };
  const logout = () => {
    localStorage.removeItem("empco_token");
    localStorage.removeItem("empco_user");
    setUser(null);
  };
  const refresh = async () => {
    const { data } = await api.get("/auth/me");
    setUser(data);
    localStorage.setItem("empco_user", JSON.stringify(data));
  };

  return <AuthCtx.Provider value={{ user, ready, login, register, logout, refresh }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
